module.exports = __webpack_public_path__ + "static/media/Logo.6a1bc138.png";